export default "__VITE_ASSET__b21ca257__"